import { render, staticRenderFns } from "./TransactionsTab.vue?vue&type=template&id=13c66adc"
import script from "./TransactionsTab.vue?vue&type=script&lang=js"
export * from "./TransactionsTab.vue?vue&type=script&lang=js"
import style0 from "./TransactionsTab.vue?vue&type=style&index=0&id=13c66adc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports